enum ProvinceCountries {
  UnitedStates = 'US',
  Canada = 'CA',
}

export default ProvinceCountries;
